import React from "react";
import { createRoot } from "react-dom/client";
// import App from "./App";
import "./styles.css";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';


const root = createRoot(document.getElementById("root"));
root.render(<App />);
